import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import HomeNav from '../../../../components/HomeNav';

import 'bootstrap/dist/css/bootstrap.min.css';

const SISafetyOverview = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('Notices');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Safety</Breadcrumb.Item>
							<Breadcrumb.Item active>Safety Overview</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 safety-element">
								<Tab eventKey="Notices" title="Notices">
									<h2>EXPLANATION OF NOTICES</h2>

									<p>Caution, Warning, and Danger notations are used throughout this manual to alert the reader to safety concerns which, if procedures are not properly performed, could cause death, serious injury or equipment damage. The boxed Caution, Warning, and Danger notations will always appear before the information or step to which they pertain. These notations are listed below in ascending order of importance. Safety instructions in this operating manual are marked as follows:</p>

									<div class="caution">
										<p>
											Indicates hazards and unsafe practices which <b>COULD</b> result in minor personal injury or product or property damage.
										</p>
										<p>Message indicates a low/minor hazard level situation, where a nonimmediate or potential hazard or unsafe practice presents a lesser</p>
										<p>threat of injury to the employee, or which could result in damage to the machine and equipment </p>
									</div>

									<div class="warning">
										<p>
											Indicates potential, moderate risk hazards and unsafe practices which <b>COULD</b> result in severe personal injury.
										</p>
										<p>Message indicates a medium hazard level situation, with the potential for moderate to major injury, without long term consequences to the employee.</p>
									</div>

									<div class="danger">
										<p>
											Indicates immediate hazards which <b>WILL</b> result in severe personal injury or death.
										</p>
										<p>Message indicates a high/major hazard situation, where an immediate hazard presents a threat of loss of life or serious/disabling injury to the employee.</p>
									</div>
									<div class="note">
										<p>Generally used to highlight a suggestion or stress important information;</p>
										<p>may also bring attention to a unique operating condition or provide a clarifying statement.</p>
									</div>

									<p>Due to variations found in the operating conditions of certain applications and their working environments, the special notations in this manual cannot identify all potential problems or hazards. Caution and discretion must always be used while operating machinery, especially when using electrical power. Equipment should be operated and maintained only by trained personnel.</p>
								</Tab>

								<Tab eventKey="Safety Overview" title="Safety Overview">
									<h2>SAFETY OVERVIEW</h2>
									<div class="note">
										<p>This manual contains important warnings and safety instructions for observation by operation and maintenance personnel. Use only qualified personnel capable of operating, maintaining, and observing all the required safety measures outlined in sections of this manual.</p>

										<p>Information in this Section intends to supplement—not replace—plant safety rules, local/state/national codes, or laws.</p>

										<p>
											In relation to this machine, personnel must follow all current Lockout and Tagout (<b>LOTO</b>) guidelines prescribed by the plant.
										</p>
									</div>
									<p>The objectives of this Safety Section are to:</p>
									<ul>
										<li>
											Define the Lockout / Tagout Procedures. (<b>LOTO</b>)
										</li>
										<li>Explain Energy Control & Reliability.</li>
										<li>Describe the location and utility of all safety features.</li>
										<li>Provide general guidelines for personal, mechanical, and electrical safety.</li>
										<li>Illustrate the locations of lockouts and safety features for the station.</li>
										<li>Isolate the identified potential hazardous energy sources, including stored energy. Lockout the hazardous energy sources with assigned safety padlocks.</li>
										<li>A qualified person shall use test equipment to test electrical circuit elements and parts of the equipment to which there will be employee exposure and shall verify that circuit elements and equipment parts are de-energized.</li>
									</ul>
									<p>Always ensure:</p>
									<ul>
										<li>The equipment or process is clear of tools and materials.</li>
										<li>
											There are <b>NO</b> personnel in the process area, machine path or point of operation.
										</li>
										<li>
											Lockout devices are applied and removed in a safe manner and <b>LOTO</b> safety procedures are followed.
										</li>
										<li>After servicing and/or maintenance is completed and the equipment can be returned to normal production operation, determine that no personnel in the area are exposed, remove all personal tools from the equipment, re-install safety guards, remove lockout devices, and return lock(s) to the proper place. Notify affected employees that the equipment is about to be restarted. Operate the isolated energy devices to restore energy, and then cycle the equipment to ensure proper operation.</li>
										<li>
											If work on the equipment is not completed by the end of shift, follow <b>LOTO</b> procedures.
										</li>

										<li>Everyone is responsible for his or her own safety. After assuring that no personnel are exposed, and successfully disconnecting the energy source, the push buttons or normal operating controls will be manipulated to make certain.</li>
									</ul>
									<p>Exclusive control is defined as providing the employee conducting the assigned task with exclusive control for startup of the equipment. It is most applicable under the following conditions:</p>
									<ul>
										<li>The assigned task requires the machine or equipment to be energized for troubleshooting, testing, positioning, and other purposes.</li>
										<li>The assigned task is routine, repetitive, and integral to the normal production operation and it does not require the dismantling or replacement of major machine or equipment components.</li>
									</ul>
									<p>Devices utilized for exclusive control are:</p>
									<ul>
										<li>Circuit control devices, such as emergency stop and start controls, providing they render the equipment inoperative and are secured by the employee, thus preventing operation without his/her knowledge and consent.</li>
										<li>Normal production safeguarding devices, such as interlocked gates, light screens, and presence-sensing mats, providing they also safeguard the employee during the maintenance task, are under his/her presence in the sensing zone.</li>
									</ul>
								</Tab>

								<Tab eventKey="General Safety" title="General Safety">
									<h2>GENERAL SAFETY GUIDELINES</h2>
									<div class="note">
										<p>Other company, industry and/or government mandated safety guidelines may also apply.</p>
									</div>
									<p>The following general safety guidelines are an overview of the safety topics covered in this section. While these guidelines provide information that will help prevent personnel injury and damage to equipment, read the entire section in this manual as well as the safety sections in the OEM documentation provided with this manual for a thorough understanding of safety practices and specific devices related to the equipment.</p>
									<ul>
										<li>Read this entire manual as well as the OEM documentation supplied with this manual and become thoroughly familiar with the machine operation and safety features before working on any part of the system.</li>
										<li>Follow all System Operating Safety precautions outlined in this manual and supplied OEM documentation.</li>
									</ul>
									<p>The following guidelines must be followed to promote the safety of the operation and maintenance personnel:</p>
									<ul>
										<li>Adopt good work habits regarding safety when working on or around the system.</li>
										<li>Always maintain clean and safe work areas.</li>
										<li>Read and obey all signs posted on and around the system.</li>
										<li>Do not remove or tamper with any safety guards, safety interlock devices, or other safety equipment built into the system. Operators must not try to defeat any safety feature. Doing so could result in severe personal injury.</li>
										<li>
											Always dress properly for the job and use appropriate sight and hearing protection. Personal Protection Equipment (<b>PPE</b>) approved safety glasses must be worn by anyone working near the line. When required, personnel must wear protective work gloves to protect themselves from cuts or lacerations that can result from the sharp edges of metal parts used in this process. Do not wear gloves near moving parts. Ear protection and hard hats may also be required where applicable based on plant dictates.
										</li>
										<li>
											When equipment is shut down by proximity limit switches, Emergency Stop pushbuttons, or other safety devices; no person should begin maintenance repairs until the shutdown procedures are completed and the system locked out observing arc flash and lockout procedures using the proper Personal Protection Equipment (<b>PPE</b>) where applicable.
										</li>
										<li>
											Know the location of the Lockout / Tagout (<b>LOTO</b>) placard and properly follow all posted procedures.
										</li>
										<li>Become thoroughly familiar with the location and function of all safety devices on the system including emergency stop push buttons and lockout valves.</li>
										<li>Understand the system's stack light color coding.</li>
										<li>Follow all Electrical, Fluid, and Mechanical System safety precautions outlined in this manual and dictated by plant safety specifications.</li>
										<li>Use tools properly and safely whenever working on the system.</li>
									</ul>
								</Tab>

								<Tab eventKey="Personal Safety" title="Personal Safety">
									<h2>PERSONAL SAFETY</h2>
									<h5>Overview</h5>
									<p>Accidents do not occur as the result of a single cause, but may occur because of an interaction between working conditions, human error, and other events. Given the complexity of machine technology, some accidents will inevitably occur. However, an error in judgment will always be the weakest link in the chain of events leading to an accident. Even under the best circumstances, judgment is affected by:</p>
									<ul>
										<li>Knowledge (and lack of knowledge) of the system and peripheral equipment.</li>
										<li>Personal work habits on the job.</li>
										<li>Physical and mental fitness on the job.</li>
									</ul>

									<h5>Knowledge First</h5>
									<p>It is vitally important for anyone working on a system to become thoroughly familiar with its operation before working with it. Knowledge of the system will help to avoid accidents. Read and understand all safety instructions before setting up, operating, maintaining, or servicing the system. Know the location and function of all safety devices provided with the system and check regularly to ensure their proper operation.</p>

									<h5>Work Habits</h5>
									<p>Personal safety combines knowledge, positive attitudes, and good work habits into a proactive awareness of potential hazards. Safe actions occur when an awareness of the importance of safety, combined with an understanding of tasks, becomes part of daily work habits on the job.</p>
									<p>You have a responsibility to conduct your daily work actions safely. Adopt a professional attitude toward safety and develop personal safety skills you can depend on-for life!</p>

									<h5>Fitness for Duty</h5>
									<p>"Fitness for Duty” means; the state of being physically and mentally fit to perform job-related duties. It is important to reduce or eliminate anything that impairs job-related judgment.</p>
									<p>Alertness is essential for sound judgment, and nothing affects alertness more adversely than fatigue. Several causes are:</p>
									<ul>
										<li>
											<b>Lack of sleep</b> - The most common cause of fatigue; continued loss of sleep causes increased nervousness and decreased reaction time. This affects the ability to react quickly to a situation
										</li>
										<li>
											<b>Poor eyesight</b> - Tired eyes lead to drowsiness, decrease your depth perception, and reduce field of vision.
										</li>
										<li>
											<b>Emotional stress</b> - A buildup of emotional stress causes tension, irritability, and mental distraction.
										</li>
										<li>
											<b>Anger</b> - If not managed appropriately, it causes drowsiness, impairs concentration and job performance.
										</li>
										<li>
											<b>Physical problems</b> - Even minor ailments (headache, indigestion, sore throat) and other conditions-such as consuming a heavy meal can impair judgment, cause sluggishness, or make you drowsy.
										</li>
										<li>
											<b>Drug and alcohol use</b> - The resulting drowsiness, nausea, or dizziness dulls reflexes and turns you into an “accident waiting to happen”.
										</li>
									</ul>

									<h5>Dressing for Safety</h5>
									<p>Unless plant safety specifications indicate otherwise, always follow these guidelines:</p>
									<ul>
										<li>Do not wear loose or baggy clothes. They should fit close to the body, but not so tight as to hinder free movement.</li>
										<li>Do not wear ties or scarves around the system at any time.</li>
										<li>Do not wear jewelry such as rings, bracelets, and necklaces around the system at any time. Wear medical alert jewelry with caution.</li>
										<li>Do not wear gloves unless handling hot, rough, or sharp surfaces.</li>
										<li>Wear shoes approved by plant safety specifications.</li>
										<li>Wear the correct protective clothing, especially when a job calls for it.</li>
										<li>Tie back long hair or restrain it with a cap or net.</li>
										<li>Wear a hard hat or other appropriate protection when a job requires it or where a risk of falling objects or overhead moving parts may exist.</li>
									</ul>

									<h5>Eye Protection</h5>
									<p>To reduce the risk of eye injury, wear the proper eye protection. Choose eye protection equipment that will best protect your eyes against an injury that may result from the type of work performed. Unless plant safety specifications indicate otherwise, safety glasses with side shields will be sufficient for normal system operation. Always keep eyewear clean.</p>

									<h5>Hearing Protection</h5>
									<p>To reduce the risk of long-term hearing damage, use hearing protection appropriate for the job. Choose hearing protection equipment (foam earplugs, padded headset) that protects against noise levels produced by the system and surrounding systems. However, do not select hearing protection that will totally muffle all noise. During system operation, it is important to hear any unusual noises that may indicate a problem. Check with your plant safety specifications to determine the best hearing protection for the job and the area where the job is performed.</p>
								</Tab>

								<Tab eventKey="Work Area Safety" title="Work Area Safety">
									<h2>WORK AREA SAFETY</h2>

									<h5>Cleanliness</h5>
									<p>Always keep work areas clean and free of hazardous obstructions. Be aware of protruding machine components. Keep floors clean and dry. Clean up chemical (cleaning solvent, beverage) and process fluid spills immediately. Follow plant-approved procedures to clean up all spills.</p>

									<h5>Guards and Covers</h5>
									<p>Safety guards, covers, gates, and barriers must always be installed while the system is operating. They should be removed only for maintenance and service purposes. If guards and covers are removed for maintenance or service, they must be re-installed before system operation can resume. Electrical interlocks, limit and proximity switches used on gates or safety guards must never be jumpered-out or bypassed.</p>

									<h5>Traffic Areas</h5>
									<p>Keep aisles, pathways, and catwalks clear of obstructions to allow free movement in all directions. Do not block their access with items such as boxes, tool chests, or ladders. This is especially true in case of an emergency, where rescue personnel must have quick access to an injured worker.</p>

									<h5>Unsafe Conditions</h5>
									<p>Immediately report any unsafe working conditions to your supervisor or safety department. Faulty safety devices, damaged hoses, and loose or broken parts all pose a safety hazard. Report all fluid leaks (oil) and unusual odors (excessive vapors, overheated metal).</p>

									<h5>Tool Usage</h5>
									<p>Tool usage safety guidelines; as they apply to the system, are as follows:</p>
									<ul>
										<li>Do not leave any tools (hand or electric) on or around the system. Any machine vibration may cause tools to fall into moving automation and cause extensive damage.</li>
										<li>When repairing or adjusting any part of the system, use the proper tool for the job. The incorrect size or type of tool may damage the system components.</li>
									</ul>
								</Tab>

								<Tab eventKey="LOTO" title="Lockout/Tagout Placard (LOTO)">
									<h2>
										Lockout/Tagout Placard (<b>LOTO</b>)
									</h2>
									<p>Safety Lockouts are a set of safety standards used to describe all potential hazards and energy sources associated with a machine. These hazards include all electrical energy (i.e., motors, switches) as well as any stored energy (i.e., pneumatic pressure, hydraulic pressure, water pressure, mechanical gravity devices). With Lockout standards, operating and maintenance work on the machine and associated mechanical devices can be performed in a safe manner. The Lockout placards are posted on the equipment in a location that is easily accessible to the operating and maintenance personnel, typically on the main electrical panel.</p>

									<p>The Lockout consists of a Graphics Placard that identifies the type and location of each energy source shown on a plan view of the machine and a Procedure Placard describing how to Lockout and verify the Lockout of each energy source. The Lockout and hazard locations on the graphics placard designated the type of energy source with symbols (i.e., E1, E2, E3, P1, W1, W2, G1 and G2). These symbols correspond to tags posted on the machine near the energy source for easy identification of the Lockout point.</p>
									<p>
										<b>ALWAYS</b> follow the instructions on the sign(s) <b>POSTED ON THE EQUIPMENT</b> for proper Lockout. Before performing any maintenance or repair work:
									</p>
									<ul>
										<li>Consult the placard lockout procedures posted on the equipment before performing any maintenance or repair task. No person should begin maintenance repairs until the proper LOCKOUT procedures are completed. The employee should contact his/her immediate supervisor if there are any questions about the identification of potential energy sources.</li>
										<li>When service or maintenance is to be conducted, equipment must be put in the OFF position via energy isolating devices such as electrical disconnects and valves. </li>
										<li>Before shutting down the equipment to Lockout energy sources, the employee performing the procedure or the supervisor shall inform affected employees of the intention to shut down the equipment.</li>
									</ul>
									<p>If the machine or equipment is operating, it must be shut down using normal shut down procedures.</p>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SISafetyOverview;
